// extracted by mini-css-extract-plugin
export default {"products":"Qx-z","card":"Rx-z","oosMessaging":"Sx-z"};